/**
 * Gets formatted phone number
 * @source Original location: UiUtils.ts.backup line 1983
 */
export const getFormattedPhoneNumber = (phone: string) => {
	if (!phone) {
		return '';
	}

	const regex = /\d+/g;
	const parsed = phone.match(regex)?.join('') ?? '';

	if (parsed.length !== 10) {
		return phone;
	}

	const areaCode = parsed.slice(0, 3);
	const first = parsed.slice(3, 6);
	const last = parsed.slice(6, phone.length);
	return `(${areaCode}) ${first}-${last}`;
};

/**
 * Fixes phone number area code
 * @source Original location: UiUtils.ts.backup line 2001
 */
export function fixPhoneNumberAreaCode(value: string) {
	if (!value) {
		return '';
	}
	const regex = /\((\d{2})\)/;
	const replacement = '(0$1)';
	const result = value.replace(regex, replacement);
	return result;
}

/**
 * Gets partial formatted phone number
 * @source Original location: UiUtils.ts.backup line 2011
 */
export const getPartialFormattedPhoneNumber = (partialPhone: string) => {
	if (!partialPhone) {
		return '';
	}

	if (partialPhone.startsWith('+')) {
		return partialPhone;
	}

	const regex = /\d+/g;
	const parsed = partialPhone.match(regex)?.join('') ?? '';

	if (parsed.length === 0) {
		return '';
	}

	const areaCode = parsed.length <= 3 ? parsed : parsed.slice(0, 3);
	const first = parsed.length > 3 ? parsed.slice(3, parsed.length <= 6 ? parsed.length : 6) : '';
	const last = parsed.length > 6 ? parsed.slice(6, parsed.length <= 10 ? parsed.length : 10) : '';
	const ext = parsed.length > 10 ? parsed.slice(10, parsed.length) : '';
	let result = `(${areaCode})`;
	if (first) {
		result += ` ${first}`;
	}
	if (last) {
		result += `-${last}`;
	}
	if (
		ext ||
		(last &&
			(partialPhone[partialPhone.length - 1] === ' ' || partialPhone[partialPhone.length - 1].toLowerCase() === 'e'))
	) {
		result += ` ext. ${ext}`;
	}
	return result;
};

export const connectEmailIsDifferent = (userEmail: string, userConnectedEmail: string) => {
	if (userEmail && userConnectedEmail && userEmail.toLowerCase() !== userConnectedEmail.toLowerCase()) {
		return true;
	}
	return false;
};
